import { render, staticRenderFns } from "./AccountPlusOutline.vue?vue&type=template&id=2b5ed9da"
import script from "./AccountPlusOutline.vue?vue&type=script&lang=js"
export * from "./AccountPlusOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports